import { render, staticRenderFns } from "./StudentInfoPage.vue?vue&type=template&id=7e70a6cc&"
import script from "./StudentInfoPage.vue?vue&type=script&lang=ts&"
export * from "./StudentInfoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports